import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const ArbitrumLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="nonzero"><rect fill="#2C374B" height={24} rx={0} width={24} /><path d="M18.498 7.755c-.116-.11-5.296-3.125-5.894-3.43-.264-.137-.75-.173-1.029-.076-.324.106-5.807 3.304-6.03 3.512-.12.117-.222.25-.304.396-.096.196-.102.334-.117 3.988l-.01 3.78.7.41c.385.224.73.41.755.42.055.016 5.032-7.91 5.032-8.016 0-.076-1.125-.06-1.525.02-.416.092-.781.274-.989.497-.086.091-.78 1.135-1.54 2.32-.468.738-.943 1.471-1.425 2.2-.025.03-.045-1.07-.045-2.574V8.577l.142-.127c.243-.223 5.63-3.31 5.772-3.31.137 0 .213.042 1.46.761.42.243 1.545.891 2.508 1.44.962.552 1.8 1.059 1.865 1.125l.111.125v5.453L15.261 9.94c-.1-.167-.206-.33-.318-.488l-.009-.015h-.001c-.02-.024-.033-.038-.038-.038-.02.005-.158.227-.77 1.261-.077.127-.188.32-.244.427l-.106.192v.001l-.002.002.077.126.056.099c.018.03.037.059.055.085l.177.292c.022.048.053.102.088.155.08.122.187.294.238.385a.474.474 0 0 0 .04.062l2.193 3.607-.261.152c-.15.084-.22.122-.265.124l-2.742-4.262-.07-.114-.248.406-.018.03-1.071 1.741-.003.002 2.141 3.366c-.272.214-2.081 1.454-2.199 1.454-.13 0-2.499-1.627-2.468-1.683.01-.021.74-1.26 1.627-2.765l.002-.002 2.314-3.927c.76-1.287 1.074-1.86 1.023-1.875-.035-.015-.542-.02-1.12-.01l-1.054.015-2.433 4.008c-.895 1.48-1.704 2.813-2.16 3.564v.001l-.383.631-.112.183 1.885 1.085c1.04.598 2.028 1.16 2.204 1.256.37.198.796.263 1.096.162.196-.06 5.766-3.268 6.045-3.476.086-.066.233-.264.319-.44l.152-.315-.01-3.523-.015-3.521-.122-.238a1.596 1.596 0 0 0-.253-.366v-.001Z" fill="#FFF" /><path d="m18.038 14.188-3.14-4.816-1.177 1.887 3.038 5.012 1.33-.64-.051-1.443Zm-1.53 2.628L13.368 12l-1.351 2.154 2.52 4.035 1.612-.654.359-.719Z" fill="#24A2EE" /><path d="M6.13 8.62 12 5.24l5.87 3.38v6.76L12 18.76l-4.307-2.48-.575.936 4.722 2.721c.1.057.223.057.322 0l6.645-3.829a.321.321 0 0 0 .162-.279V8.172a.321.321 0 0 0-.162-.28L12.16 4.065a.325.325 0 0 0-.322 0L5.194 7.893a.321.321 0 0 0-.162.279v7.656c0 .115.062.222.162.28l1.328.764.592-.926-.983-.567V8.621L6.13 8.62Z" fill="#98BCDC" /><path d="m14.552 8.696-2.267.031-5.169 8.492 1.824 1.056 5.612-9.579Zm-5.63.774c.518-.847 2-.844 2.678-.736l-5.08 8.138-.932-.536c-.437-.25-.51-.257-.556-.49v-.45c1.08-1.623 3.373-5.08 3.89-5.926" fill="#FFF" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const ArbitrumLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm11.575 4.249c-.143.047-1.29.695-2.547 1.423l-.506.295c-1.439.839-2.865 1.69-2.977 1.794-.12.117-.222.25-.304.396-.096.196-.102.334-.117 3.988l-.01 3.78.7.41c.385.224.73.41.755.42a.495.495 0 0 0 .068-.09l.105-.156c.885-1.336 4.859-7.675 4.859-7.77 0-.076-1.125-.06-1.525.02-.416.092-.781.274-.989.497-.086.091-.78 1.135-1.54 2.32-.468.738-.943 1.471-1.425 2.2-.023.027-.041-.87-.044-2.156l-.001-3.043.142-.127c.243-.223 5.63-3.31 5.772-3.31l.039.002c.123.012.293.108 1.421.759.42.243 1.545.891 2.508 1.44.962.552 1.8 1.059 1.865 1.125l.111.125v5.453L15.261 9.94c-.1-.167-.206-.33-.318-.488l-.009-.015c-.021-.024-.034-.038-.039-.038a.404.404 0 0 0-.073.1l-.055.087c-.108.176-.302.5-.642 1.074-.077.127-.188.32-.244.427l-.106.192.075.129.056.099c.018.03.037.059.055.085l.177.292c.022.048.053.102.088.155.08.122.187.294.238.385a.474.474 0 0 0 .04.062l2.193 3.607-.261.152c-.15.084-.22.122-.265.124l-2.742-4.262-.07-.114-.248.406-.018.03-1.071 1.741 2.138 3.368c-.115.09-.502.362-.92.647l-.316.213c-.472.316-.907.594-.963.594-.13 0-2.499-1.627-2.468-1.683 0-.002.007-.013.019-.032l.126-.216c.257-.438.826-1.405 1.482-2.517l2.316-3.929c.76-1.287 1.074-1.86 1.023-1.875-.035-.015-.542-.02-1.12-.01l-1.054.015-2.433 4.008c-.895 1.48-1.704 2.813-2.16 3.564l-.383.632-.112.183 1.885 1.085c1.04.598 2.028 1.16 2.204 1.256.37.198.796.263 1.096.162.196-.06 5.766-3.268 6.045-3.476.086-.066.233-.264.319-.44l.152-.315-.01-3.523-.015-3.521-.122-.238a1.596 1.596 0 0 0-.253-.366c-.116-.111-5.296-3.126-5.894-3.431-.264-.137-.75-.173-1.029-.076Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};